import React, { useState, useEffect, useContext } from "react";
import CustomSlider from "./common/CustomSlider";
import TooltipSlider from "./common/TooltipSlider";
import "rc-slider/assets/index.css";
import _ from "lodash";
import {
	CodesToColorMapFunc,
	BgColorToTextColorMapFunc,
} from "../CodesToColorMap";
import { DiseaseGroupContext } from "../contexts/diseaseGroupContext";

export const QuestionnaireHorizontalScalePage = ({
	def,
	onRespond,
	currentResponse,
	code,
}) => {
	const [sliderValue, setSliderValue] = useState(null);

	const { theme } = useContext(DiseaseGroupContext);

	const [textColor, setTextColor] = useState("white");

	useEffect(() => {
		const themeTextColor = BgColorToTextColorMapFunc(
			CodesToColorMapFunc(code, theme)
		);
		setTextColor(themeTextColor);
	}, []);

	useEffect(() => {
		if (currentResponse && currentResponse.value) {
			setSliderValue(currentResponse.value);
		} else if (def.answer) {
			setSliderValue(def.answer);

			const response = {
				id: def.id,
				value: def.answer,
			};

			onRespond(response);
		}
	}, [currentResponse, def, onRespond]);

	const handleChange = (value) => {
		setSliderValue(value);

		const response = currentResponse ?? {
			id: def.id,
			value: value,
		};

		response.value = value;

		onRespond(response);
	};

	const marks = {};

	if (def.bounds.hideAllMarks === true) {
	} else {
		const markRange = def.bounds.marks ?? [def.bounds.min, def.bounds.max];

		for (const m of markRange) {
			marks[m.toString()] = {
				style: {
					color: textColor,
					marginTop: 10,
					fontSize: "14px",
				},

				label: m.toString(),
			};
		}
	}

	return (
		<div className={"mx-3 xs:mx-6"}>
			<div className={"flex flex-row"}>
				<div className={"flex-1 my-auto mx-3 pb-3 xs:pb-6"}>
					<p className={"text-sm text-center lg:text-base mb-3 xs:mb-6"}>
						{def.instructions.top}
					</p>
					<div
						className={
							"flex flex-col justify-center bg-black w-64 min-h-36 xs:min-h-44 h-fit rounded-md text-white text-center p-2 xs:p-3 mx-auto"
						}
					>
						<span>
							{def.question}
							{def.hideQuestionBoxValue === true ? null : " ="}
						</span>
						{def.hideQuestionBoxValue === true ? null : (
							<p className="text-white">{sliderValue ?? "Tap on the scale"}</p>
						)}
					</div>
					<p className={"text-sm text-center lg:text-base pt-3"}>
						{def.instructions.bottom}
					</p>
				</div>
			</div>
			<div className={"flex mt-5 xs:mt-10 flex-row"}>
				<div className={"flex-1 ml-2 mr-1 xs:mr-0 text-center"}>
					<TooltipSlider
						min={def.bounds.min}
						max={def.bounds.max}
						vertical={false}
						reverse={def.bounds.reverse === true}
						included={def.hideSliderGauge !== true}
						hideTooltip={def.hideSliderTooltip}
						value={sliderValue}
						onChange={handleChange}
						trackStyle={{
							backgroundColor: "#F2413C",
							borderColor: "#F2413C",
							height: 10,
							marginTop: -4,
						}}
						handleStyle={{
							borderColor: "#F2413C",
							height: 40,
							width: 40,
							marginTop: -19,
							marginLeft: -5,
							opacity: 1,
							backgroundColor: "#F2413C",
						}}
						railStyle={{
							backgroundColor: "darkgrey",
							height: 6,
							margin: 2,
							marginTop: -2,
						}}
						marks={marks}
						dotStyle={{
							backgroundColor: "grey",
							width: 10,
							height: 10,
							borderColor: "grey",
						}}
					/>
					<div
						className={`w-full ${
							def.bounds.hideAllMarks ? "mt-4" : "mt-9 xs:mt-10"
						} grid grid-cols-2`}
					>
						<p className="text-sm -ml-1 text-left leading-tight justify-self-start w-24">
							{def.bounds.maxLabel}
						</p>
						<p className="text-sm -mr-1 text-right leading-tight justify-self-end w-24">
							{def.bounds.minLabel}
						</p>
					</div>
					<div className="pt-2">
						<p className="w-full text-sm text-center">
							{def.sliderDescription}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};
